import request from '@/api/request'

// 首页
export function articles() {
  // DfWY6Zn55pnLljiL
  return request({
    // url: `/japi`,
    // url: `/japi2`,
    // url: `/japi5`,
    url: `/japi7`,
    // url:'',
    // url:`https://japi.xhby.net/v4/api/articles/FIsxXOm9b139YPbv`,
    // url: `https://japi.xhby.net/v4/api/articles/galtHNfqUNvVKMnf`,
    method: 'get'
  })
}
// 分享
export function signature(_data) {
  let href = ''
  if(window.location.href.indexOf('https')!=-1){
    href = 'https://jshare.xhby.net'
  }else{
    href = 'http://jshare.xhby.net'
  }
  return request({
    url: href + `/api/signature`,
    method: 'post',
    data:_data
  })
}


// WEBPACK FOOTER //
// ./src/api/common/index.js